import { products } from '~/App/helpers/http';
import { LoadDataProps } from '~/types/routes';

export async function loadData({ params }: LoadDataProps<'slug'>) {
  return {
    product: await products.show(params?.slug ?? '')
  };
}
